<template>
  <div>
    <MarketReleaseFundsDialog
      v-model="releaseFundsModal"
      :market="releaseFundsModalMarket"
      @closeFundModal="releaseFundsModal = false"
    ></MarketReleaseFundsDialog>
    <exchange-tabs v-model="activeExchangeTab">
      <template slot-scope="slotProps">
        <v-layout row wrap class="tab-title">
          <v-flex offset-md4 offset-lg4 xs12 md4 lg4 class="text-xs-center">
            <h2 class="title text-xs-center" style="padding-top: 14px;">
              Accumulated funds <br v-if="isMobile" />
              (Buy history)
              <v-icon
                class="vertical-align-middle icon-for-information"
                style="font-size: 20px;"
                @click="$emit('clicked', '')"
                >fa-info-circle</v-icon
              >
            </h2>
          </v-flex>
          <v-flex xs12 md4 lg4 class="text-xs-center btn-historic-area">
            <v-btn
              round
              class="btn-add-historic"
              @click.stop="$emit('addHistoryBtnClick', '')"
            >
              <span v-if="showShortBtn">Add historic buy order</span>
              <span v-else>Manually add historic buy order</span>
              &nbsp;
              <IconBase
                icon-name="Manually add historic buy order"
                width="11"
                height="11"
                view-box="0 0 11 11"
              >
                <AddHistoricBuyOrderDark v-if="darkmode" />
                <AddHistoricBuyOrderLight v-else />
              </IconBase>
            </v-btn>
          </v-flex>
        </v-layout>
        <base-market-tabs
          v-model="activeTab[slotProps.exchange]"
          :exchange="slotProps.exchange"
        >
          <template slot-scope="slotProps">
            <v-data-table
              :headers="tableHeaders"
              :items="
                slotProps.markets.filter(market => market.quantity_reserved > 0)
              "
              :disable-initial-sort="true"
              item-key="name"
              class="markets-table"
            >
              <template slot="items" slot-scope="props">
                <tr v-if="!isMobile">
                  <td>
                    {{ props.item.target_currency }}
                  </td>
                  <td>
                    {{ props.item.quantity_reserved  | roundNumber(8)}}
                  </td>
                  <td>
                    <a
                      v-if="props.item.quantity_reserved > 0"
                      href="#"
                      @click.prevent="showReleaseFundsModal(props.item)"
                      >Show / Remove completed buy orders</a
                    >
                  </td>
                </tr>
                <tr v-else>
                  <td class="pb-3 pt-2">
                    <v-layout row wrap>
                      <v-flex md12 xs12>
                        <v-layout row wrap>
                          <v-flex xs6 lg6 md6>
                            Currency
                          </v-flex>
                          <v-flex xs6 lg6 md6>
                            {{ props.item.target_currency }}
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs6 lg6 md6>
                            Reserved for selling
                          </v-flex>
                          <v-flex xs6 lg6 md6>
                            {{ props.item.quantity_reserved  | roundNumber(8)}}
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12 lg12 md12>
                            <a
                              v-if="props.item.quantity_reserved > 0"
                              href="#"
                              @click.prevent="showReleaseFundsModal(props.item)"
                              >Show / Remove completed buy orders</a
                            >
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </template>
        </base-market-tabs>
      </template>
    </exchange-tabs>
  </div>
</template>

<style scoped>
.markets-table {
  margin-right: 104px;
  margin-left: 104px;
  margin-top: 28px;
}
>>> .v-datatable__actions {
  padding-top: 16px;
  padding-bottom: 16px;
}
.theme--light .tab-title {
  background-color: #ffffff;
  box-shadow: 4px 6px 10px rgba(57, 95, 169, 0.18);
  border-radius: 0px 15px 0px 0px;
  padding-bottom: 18px;
  padding-top: 32px;
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.theme--light .btn-add-historic {
  border: 1px solid #103a84;
  box-sizing: border-box;
  border-radius: 70px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
  background-color: #ffffff !important;
  box-shadow: none !important;
}
.theme--light .title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
}
/************************/
.theme--dark td a {
  color: #e9e9e9;
}
.theme--dark .tab-title {
  background-color: #212121;
  box-shadow: none !important;
  border-radius: 0px 15px 0px 0px;
  padding-bottom: 18px;
  padding-top: 32px;
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.theme--dark .btn-add-historic {
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
  border-radius: 70px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #e9e9e9;
  background-color: #212121 !important;
  box-shadow: none !important;
}
.theme--dark .title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #e9e9e9;
}

@media (max-width: 960px) {
  .markets-table {
    margin-right: 16px;
    margin-left: 16px;
    margin-top: 28px;
  }
  .btn-historic-area {
    padding-top: 20px !important;
  }
}
</style>
<script>
import { mapGetters } from "vuex";
import MarketReleaseFundsDialog from "~/components/dashboard/MarketReleaseFundsDialog.vue";
import swal from "sweetalert2";
import IconBase from "../icons/IconBase";
import AddHistoricBuyOrderLight from "../icons/AddHistoricBuyOrderLight";
import AddHistoricBuyOrderDark from "../icons/AddHistoricBuyOrderDark";

export default {
  components: {
    MarketReleaseFundsDialog,
    IconBase,
    AddHistoricBuyOrderLight,
    AddHistoricBuyOrderDark
  },
  data: function() {
    return {
      releaseFundsModal: false,
      releaseFundsModalMarket: null,
      windowWidth: window.innerWidth,

      activeExchangeTab: 0,
      activeTab: {
        Binance: 0,
        Bittrex: 0
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      baseCurrencies: "markets/markets",
      darkmode: "settings/darkmode"
    }),
    tableHeaders: function() {
      if (this.isMobile) {
        return [
          {
            text: "Currency",
            value: "market_name"
          }
        ];
      } else {
        return [
          {
            text: "Currency",
            value: "market_name"
          },
          {
            text: "Reserved for selling",
            value: "quantity_reserved"
          },
          {
            text: "Actions",
            value: null
          }
        ];
      }
    },
    isMobile() {
      return this.windowWidth < 600;
    },
    showShortBtn() {
      return this.windowWidth <= 340;
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
  methods: {
    showReleaseFundsModal: function(market) {
      this.releaseFundsModalMarket = market;
      this.releaseFundsModal = true;
    }
  },
  infoAlert: async function(title, text) {
    await swal({
      title: title,
      html: text,
      type: "info"
    });
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/openorders/MarketActions.vue